import { AIProvider } from '../types/ai';

export const aiProviders: AIProvider[] = [
  {
    id: 'openai',
    name: 'ChatGPT',
    icon: '🤖',
    logo: 'GPT',
    color: 'bg-green-600',
    description: 'Modelos GPT da OpenAI para conversação e tarefas complexas',
    models: [
      { id: 'gpt-5.1-2025-11-13', name: 'GPT-5.1', description: 'Modelo mais avançado da OpenAI - Nova geração' },
      { id: 'gpt-5-2025-08-07', name: 'GPT-5', description: 'Versão otimizada do GPT-5' },
      { id: 'gpt-4o', name: 'GPT-4o', description: 'Modelo mais avançado e rápido do GPT-4' },
      { id: 'gpt-4o-mini', name: 'GPT-4o Mini', description: 'Versão compacta e eficiente do GPT-4o' },
      { id: 'gpt-4-turbo', name: 'GPT-4 Turbo', description: 'Versão otimizada do GPT-4' },
      { id: 'gpt-4', name: 'GPT-4', description: 'Modelo GPT-4 padrão' },
      { id: 'gpt-3.5-turbo', name: 'GPT-3.5 Turbo', description: 'Rápido e eficiente para tarefas básicas' }
    ]
  },
  {
    id: 'anthropic',
    name: 'Claude',
    icon: '🎭',
    logo: 'C',
    color: 'bg-orange-600',
    description: 'Assistente de IA da Anthropic com foco em segurança e utilidade',
    models: [
      { id: 'claude-opus-4-6', name: 'Claude Opus 4.6', description: 'Modelo mais capaz para tarefas complexas' },
      { id: 'claude-sonnet-4-6', name: 'Claude Sonnet 4.6', description: 'Equilíbrio entre velocidade e capacidade' },
      { id: 'claude-haiku-4-5-20251001', name: 'Claude Haiku 4.5', description: 'Rápido e leve para tarefas simples' }
    ]
  },
  {
    id: 'google',
    name: 'Gemini',
    icon: '✨',
    logo: 'G',
    color: 'bg-blue-600',
    description: 'Modelos Gemini do Google para tarefas avançadas',
    models: [
      { id: 'gemini-3-flash-preview', name: 'Gemini 3 Flash', description: 'Modelo Flash (padrão) - rápido e eficiente' },
      { id: 'gemini-3.1-pro-preview', name: 'Gemini 3.1 Pro', description: 'Versão Pro com máxima capacidade' }
    ]
  }
];